import { all, takeEvery } from 'redux-saga/effects'

import { getIdentityProgress, updateActivity } from 'store/entities/identity/actions'

export function* handleSetStopRepeatSuccess() {
  yield getIdentityProgress.call()
}

export default function* unsubscribeProgressSaga() {
  yield all([takeEvery(updateActivity.success.toString(), handleSetStopRepeatSuccess)])
}
